import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';

const makeCrmButtonStyles = makeStyles((theme) => ({
  root: {
    margin: `${theme.spacing(1)}`,
    fontSize: '1rem',
    fontWeight: 600,
  },
  whiteText: {
    color: '#ffffff',
  },
}));

const CrmButton = ({ className, outlined, filled, color, size, disabled, onClick, children }) => {
  const buttonStyles = makeCrmButtonStyles();
  const variant = outlined ? 'outlined' : filled ? 'contained' : undefined;
  const classNameToPassIn = className ? buttonStyles.root + ' ' + className : buttonStyles.root;
  const colorToPassIn = color || 'primary';
  return (
    <Button
      className={classNameToPassIn}
      color={colorToPassIn}
      variant={variant}
      disabled={disabled}
      size={size}
      onClick={onClick}
    >
      {filled ? <span className={buttonStyles.whiteText}>{children}</span> : <span>{children}</span>}
    </Button>
  );
};

export default CrmButton;
